export const FeedbackPageTitles = {
  title: 'Send feedback',
  description: 'How can we improve the KONE API portal? \n Do you have a question about KONE APIs or API portal?',
}
export const FeedbackAreas = {
  title: 'In which area you want to give feedback? *',
  area1: 'KONE API portal in general',
  area2: 'API documentation',
  area3: 'Using sandbox environment',
  area4: 'Using production environment',
  area5: 'Something else',
  errorMessage: 'Select at least one feedback area',
}
export const FeedbackInformation = {
  message: 'Your message *',
  name: 'Your name *',
  email: 'Email address for getting back to you *',
  company: 'Your company',
  privacyStatement: 'Privacy Statement.',
  invalidEmailAddressError: 'Invalid email address',
  invalidPhoneNumber: 'Invalid phone number',
  sendFormButton: 'Send',
  sendingFeedbackFailed: 'Sending feedback failed.',
}

export const FeedbackSuccessViewStrings = {
  title: 'Thank you for your feedback!',
  message: 'We have received your message and will get back to you as needed.',
}
